/**
 * HelpButton - the "?" in the header, between the Resume chip and the
 * Notifications bell (Bill 2026-09-11: "typical app location"). Routes to the
 * Help module (/help): Getting started / How do I / If something breaks / About.
 */
import { CircleHelp } from '@retail-ops/panel-shell/fi';
import { NavLink } from 'react-router';

export function HelpButton(): JSX.Element {
  return (
    <NavLink
      to="/help"
      className={({ isActive }) => `shell__topbar-iconbtn${isActive ? ' is-active' : ''}`} data-tour="topbar-help"
      aria-label="Help and About"
      title="Help - how do I, if something breaks, About this app"
    >
      <CircleHelp size={16} aria-hidden />
    </NavLink>
  );
}
